<div class="container card positionCard">
  <div class="row">
      <!--  <div class="col-md-6 col-sm-10 center-block text-center">
              <div class="page-head">We need your sign-off </div>
          </div> -->
  </div>
  <div class="row">
      <div class="col-md-6 col-sm-10 col-md-push-3 tablet-block">

          <div class="clearfix no-gutter-sm content-block head-padding">
              <div class="row">
                  <div class="col-xs-12 text-center">
                      <div class="subhead-header">Thank you for eSigning, sales representative will get back to you incase there are any other concerns.</div>
                  </div>
              </div>
              <div class="col-sm-11 ty-min-height center-block">
                  <div class="content-holder">
                      <h4 class="text-grey text-xs-center"><strong>e-signed Documents :</strong></h4>
                  </div>
                  <ul class="document-list">
                      <li *ngFor="let document of DocumentList">
                          <div class="docList">
                            <div class="data disp-ib">{{document.name}}</div>
                            <a *ngIf="document.url" (click)="downloadEsignDocument(document)"><div class="downloadIcon pull-right"></div></a>
                        </div>

                          <!-- <span class="data">{{document.name}}</span>
                          <a (click)="downloadEsignDocument()"><span class="downloadIconText" >Download Documents</span></a> -->
                          
                      </li>
                  </ul>
              </div>
          </div>
      </div>
  </div>
</div>
